import type { App } from 'vue'
import { NpButton } from './np-button'

export * from './np-button'

const components = [NpButton]

export function install(app: App) {
  components.forEach((item) => {
    if (item.install!) {
      app.use(item)
    } else if (item.name) {
      app.component(item.name, item)
    }
  })
}

export default {
  install,
}
